export const SortString = (arr = [], key, sortBy = "asc", isNon5PL = false) => {
  let res = arr.sort(function (x, y) {
    let aValue = isNon5PL ?  x[key]?.level : x[key];
    let bValue = isNon5PL ?  y[key]?.level : y[key];
    let a =
        typeof aValue === "string"
          ? aValue.trim().toUpperCase()
          : aValue === null
          ? ""
          : aValue,
      b =
        typeof bValue === "string"
          ? bValue.trim().toUpperCase()
          : bValue === null
          ? ""
          : bValue;
    if (sortBy === "desc") {
      return a === b ? 0 : a > b ? -1 : 1;
    }
    return a === b ? 0 : a > b ? 1 : -1;
  });
  return res;
};

export const sortByDisableRow = (array) => {
  return array.sort((a, b) => (a?.disableRow ? 1 : 0) - (b?.disableRow ? 1 : 0));
}

export const sortArrayWithDesireOrder = (array, key, desiredOrder, ascending) => {
  const sortedArray = array.slice().sort((a,b) => {
     const indexA = desiredOrder.indexOf(a[key]);
     const indexB = desiredOrder.indexOf(b[key]);
     if (!ascending) {
       return indexA - indexB;
     } else {
       return indexB - indexA;
     }
  })
 return sortedArray;
}